import type { ITicketOffice } from "../../../models/ticket-office.model";

export class TicketOfficeApiModel {
  public static mapToBusinessModel(apiModel: TicketOfficeApiModel): ITicketOffice {
    return {
      number: apiModel.number,
      name: apiModel.name,
      location: apiModel.location,
      latitude: apiModel.latitude,
      longitude: apiModel.longitude
    };
  }

  public number!: number;
  public name!: string;
  public location!: string;
  public latitude!: number;
  public longitude!: number;
}
